import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/site";

const fmt = (v) =>
  v
    ? new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        hour: "numeric",
        minute: "2-digit",
        timeZone: "America/New_York",
      }).format(new Date(v))
    : null;

export default function ShabbatBar() {
  const [d, setD] = useState(null);

  useEffect(() => {
    axios.get(`${API}/shabbat`).then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return null;

  return (
    <div data-testid="shabbat-bar" className="border-b border-gold/20 bg-gold/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-2 flex items-center justify-center gap-x-6 gap-y-1 flex-wrap text-[11px] tracking-wide text-foreground/70">
        <span className="font-cormorant italic text-gold text-sm" data-testid="shabbat-hebrew-date">{d.hebrew_date}</span>
        {d.parasha && <span data-testid="shabbat-parasha">{d.parasha}</span>}
        {d.candle_lighting && (
          <span data-testid="shabbat-candle-lighting">
            Candle Lighting <span className="text-gold">{fmt(d.candle_lighting)}</span>
          </span>
        )}
        {d.havdalah && (
          <span className="hidden md:inline" data-testid="shabbat-havdalah">
            Havdalah <span className="text-gold">{fmt(d.havdalah)}</span>
          </span>
        )}
      </div>
    </div>
  );
}
